<template>
  <div class="clasificacion">
    <label for="clasificacion">Clasificación</label>
    <select required v-model="clasificacion" name="clasificacion" id="clasificacion">
      <option value="">Seleccione...</option>
      <option v-for="item in clasificaciones" :value="{id: item.id, nombre: item.nombre}">{{ item.nombre | upper }}
      </option>
    </select>
    <i class="bar"></i>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";

  export default {
    name: "Clasificacion",
    computed: {
      ...mapGetters({
        clasificaciones: "producto/clasificaciones"
      }),
      clasificacion: {
        get() {
          return this.$store.state.producto.producto.clasificacion
        },
        set(value) {
          this.$store.commit("producto/SET_KEY_PRODUCTO", {key: "clasificacion", value})
          console.log(this.$store.state.producto.producto)
        }
      }
    }
  }
</script>

<style scoped>

</style>
